import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { Button } from 'antd';
import BasicInformationLine from '../../components/BasicInformationLine/BasicInformationLine';
import NoticeTypeButtons from './components/NoticeTypeButtons';
import DebtorsList from '../../components/DebtorsList/DebtorsList';
import getNoticesList from '../../store/thunks/getNoticesList';
import actions from '../../store/actions/actions';
import playNotice from '../../store/thunks/playNotice';
import getNoticesPreview from '../../store/thunks/getNoticesPreview';
import './NoticeView.scss';

const NoticeView = memo(() => {
  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const companyIdFromUrl = params.get('companyId');

  const files = useSelector((store) => store.debtsStore.files);
  const [noticeTypeView, setNoticeTypeView] = useState();
  const [openedNotice, setOpenedNotice] = useState();
  const {
    params: { noticeId, fileId },
  } = useRouteMatch('/Debts/file/:fileId/notice/:noticeId') || {
    params: {},
  };
  useEffect(() => {
    return () => dispatch({ type: actions.DEBTS_LIST_LOADED, payload: [] });
  }, []);

  useEffect(() => {
    (async () => {
      dispatch(getNoticesList(noticeId));
    })();
  }, [noticeId, noticeTypeView]);

  useEffect(() => {
    const openedFileFull = files?.find((file) => {
      return +file.fileId === +fileId;
    });
    const notice =
      openedFileFull &&
      openedFileFull.notices &&
      openedFileFull.notices?.find((notice) => {
        return +notice.id === +noticeId;
      });
    setOpenedNotice(notice);
  }, [noticeId, fileId, files]);
  const onPlayNotice = useCallback(async () => {
    await dispatch(playNotice(noticeId));
    history.push({
      pathname: `/Debts/file/${fileId}/notice/${noticeId}`,
      search: `?companyId=${companyIdFromUrl}`,
    });
    await dispatch(getNoticesPreview(fileId));
    dispatch(getNoticesList(noticeId));
  }, [noticeId, fileId]);
  return (
    <>
      <NoticeTypeButtons
        openedNotice={openedNotice}
        setNoticeTypeView={setNoticeTypeView}
        noticeTypeView={noticeTypeView}
      />
      <BasicInformationLine
        notice
        buttons={
          +openedNotice?.stateId === 1 ? (
            <Button
              type="primary"
              className="button"
              onClick={onPlayNotice}
            >
              Запустить оповещение
            </Button>
          ) : null
        }
      />
      <DebtorsList
        key="notice-debtors"
        withoutSelection={true}
        noticeTypeView={noticeTypeView}
      />
    </>
  );
});

export default NoticeView;
